import { useState, useCallback } from "react";

import Chat from "../../../../components/userChat/chat";
import DocumentFiles from "./DocumentFiles";
import TableRow from "./TableRow";

const Table = ({ list = [], documentType }) => {
    const [chatState, setChatState] = useState({ open: false, ftm: null });
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [fileViewDocumentId, setFileViewDocumentId] = useState(null);

    /* ---------------- File View ---------------- */
    const openFileView = useCallback((item, documentId) => {
        setSelectedDocument(item);
        setFileViewDocumentId(documentId);
    }, []);

    const closeFileView = useCallback(() => {
        setSelectedDocument(null);
        setFileViewDocumentId(null);
    }, []);

    const openNewDocumentFiles = useCallback(() => {
        if (selectedDocument?.doc_new_document) {
            setFileViewDocumentId(selectedDocument.doc_new_document);
        }
    }, [selectedDocument]);

    const openCurrentDocumentFiles = useCallback(() => {
        if (selectedDocument?.doc_id) {
            setFileViewDocumentId(selectedDocument.doc_id);
        }
    }, [selectedDocument]);

    /* ---------------- Chat ---------------- */
    const handleChatOpen = useCallback((ftm) => {
        if (ftm) setChatState({ open: true, ftm });
    }, []);

    const handleChatClose = useCallback(() => {
        setChatState({ open: false, ftm: null });
    }, []);

    return (
        <ul className="list-group">
            {list.map((item) => (
                <TableRow
                    key={item.doc_id}
                    item={item}
                    documentType={documentType}
                    onOpenFiles={openFileView}
                    onOpenChat={handleChatOpen}
                />
            ))}

            {chatState.open && chatState.ftm && (
                <Chat
                    user_name={`${chatState.ftm.ftm_forename} ${chatState.ftm.ftm_surname}`}
                    user_firebase_document_id={chatState.ftm.ftm_firebase_document_id}
                    show
                    handleClose={handleChatClose}
                />
            )}

            {fileViewDocumentId && (
                <DocumentFiles
                    show
                    handleClose={closeFileView}
                    documentId={fileViewDocumentId}
                    documentType={documentType}
                    openNewDocumentFiles={openNewDocumentFiles}
                    openCurrentDocumentFiles={openCurrentDocumentFiles}
                    isHaveNewDocument={selectedDocument?.doc_is_have_new_document}
                    ftmId={selectedDocument?.doc_ftm?.ftm_id}
                />
            )}
        </ul>
    );
};

export default Table;